// Lightweight GA4 helpers
export const trackEvent = (action, params = {}) => {
  if (typeof window === 'undefined') return;
  const gtag = window.gtag;
  if (typeof gtag !== 'function') return;
  gtag('event', action, params);
};

export const trackOutboundLink = (url) => {
  trackEvent('click_outbound', {
    link_url: url,
    outbound: true,
  });
};

export const trackCTA = (name, context = {}) => {
  trackEvent('cta_click', { cta_name: name, ...context });
};

export const trackForm = (name, status, context = {}) => {
  trackEvent('form_submit', { form_name: name, status, ...context });
};



